const rawBaseUrl = process.env.REACT_APP_API_BASE_URL || "https://mctp2muat.mindscraft.pk";
const trimmedBaseUrl = rawBaseUrl.endsWith("/") ? rawBaseUrl.slice(0, -1) : rawBaseUrl;

export const API_BASE_URL = trimmedBaseUrl.endsWith("/api") ? trimmedBaseUrl : `${trimmedBaseUrl}/api`;
